function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StepDonutChart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SVG = require("../SVG");
var _Text = require("../Text");
var _View = require("../View");
var _styles = require("./styles");
var _styles2 = require("../../styles");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var StepDonutChart = exports.StepDonutChart = (0, _react.memo)(function (_ref) {
  var current = _ref.current,
    total = _ref.total,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 134 : _ref$size;
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS;
  var strokeWidth = 20;
  var radius = (size - strokeWidth) / 2;
  var circumference = 2 * Math.PI * radius;
  var progress = current / total;
  var progressOffset = (1 - progress) * circumference;
  return (0, _jsxRuntime.jsxs)(_View.View, {
    style: styles.container,
    testID: "StepDonutChart",
    children: [(0, _jsxRuntime.jsxs)(_SVG.SVG.Svg, {
      width: size,
      height: size,
      testID: "StepDonutChartSvg",
      children: [(0, _jsxRuntime.jsx)(_SVG.SVG.Circle, {
        cx: size / 2,
        cy: size / 2,
        r: radius,
        fill: "transparent",
        stroke: COLORS.mushroom,
        strokeWidth: strokeWidth
      }), (0, _jsxRuntime.jsx)(_SVG.SVG.Circle, {
        cx: size / 2,
        cy: size / 2,
        r: radius,
        fill: "transparent",
        stroke: COLORS.aubergine,
        strokeWidth: strokeWidth,
        strokeDasharray: "".concat(circumference, ", ").concat(circumference),
        strokeDashoffset: progressOffset,
        transform: "rotate(-90 ".concat(size / 2, " ").concat(size / 2, ")")
      })]
    }), (0, _jsxRuntime.jsxs)(_View.View, {
      style: styles.innerContent,
      children: [(0, _jsxRuntime.jsx)(_Text.Text, {
        textStyle: styles.number,
        containerStyle: styles.textContainer,
        children: current
      }), (0, _jsxRuntime.jsx)(_Text.Text, {
        textStyle: styles.unit,
        containerStyle: styles.textContainer,
        children: t('stepDonutChart:steps')
      })]
    })]
  });
});
var _default = exports["default"] = StepDonutChart;